import Vue from 'vue'
import VueRouter from 'vue-router'

import Layout from '../components/AuthLayout.vue'

Vue.use(VueRouter)

const routes = [
   //PrimariaA
  {
    path: '/primaria-a',
    
    component: Layout,
    children: [
   
      { 
          path: 'leccion1a',
          name: 'primaria-a',
          component: () => import(/* webpackChunkName: "leccion1a" */ '../views/PrimariaA/LeccionA1.vue'),
          props:true       
      },
      { 
        path: 'leccion2a',
        name: 'primaria2a',
        component: () => import(/* webpackChunkName: "leccion2a" */ '../views/PrimariaA/LeccionA2.vue'),
        props:true       
      },
      { 
        path: 'leccion3a',
        name: 'primaria3a',
        component: () => import(/* webpackChunkName: "leccion3a" */ '../views/PrimariaA/LeccionA3.vue'),
        props:true       
      },
      { 
        path: 'leccion4a',
        name: 'primaria4a',
        component: () => import(/* webpackChunkName: "leccion4a" */ '../views/PrimariaA/LeccionA4.vue'),
        props:true       
      },
      { 
        path: 'leccion5a',
        name: 'primaria5a',
        component: () => import(/* webpackChunkName: "leccion5a" */ '../views/PrimariaA/LeccionA5.vue'),
        props:true       
      },
      { 
        path: 'leccion6a',
        name: 'primaria6a',
        component: () => import(/* webpackChunkName: "leccion6a" */ '../views/PrimariaA/LeccionA6.vue'),
        props:true       
      },
 
  ]
  },
   //PrimariaB
  {
    path: '/primaria-b',
    name:'primariab',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Layout" */ '../components/AuthLayout.vue'),
    props:true,
    children: [
   
      { 
          path: 'leccion1b',
          name:'leccion1b',
          component: () => import(/* webpackChunkName: "Leccion1b" */ '../views/PrimariaB/LeccionB1.vue'),
          props: true
      },
      { 
        path: 'leccion2b',
        name:'leccion2b',
        component: () => import(/* webpackChunkName: "Leccion2b" */ '../views/PrimariaB/LeccionB2.vue'),
        props: true
      },
      { 
        path: 'leccion3b',
        name:'leccion3b',
        component: () => import(/* webpackChunkName: "Leccion3b" */ '../views/PrimariaB/LeccionB3.vue'),
        props: true
      },
      { 
        path: 'leccion4b',
        name:'leccion4b',
        component: () => import(/* webpackChunkName: "Leccion4b" */ '../views/PrimariaB/LeccionB4.vue'),
        props: true
      },
      { 
        path: 'leccion5b',
        name:'leccion5b',
        component: () => import(/* webpackChunkName: "Leccion5b" */ '../views/PrimariaB/LeccionB5.vue'),
        props: true
      },
      { 
        path: 'leccion6b',
        name:'leccion6b',
        component: () => import(/* webpackChunkName: "Leccion6b" */ '../views/PrimariaB/LeccionB6.vue'),
        props: true
      },
  ]
  },
  // //PrimariaC
  {
    path: '/primaria-c',
    name:'primariac',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Layout" */ '../components/AuthLayout.vue'),
    props:true,
    children: [
   
      { 
          path: 'leccion1c',
          name:'leccion1c',
          component: () => import(/* webpackChunkName: "Leccion1c" */ '../views/PrimariaC/LeccionC1.vue'),
          props: true
      },
      { 
        path: 'leccion2c',
        name:'leccion2c',
        component: () => import(/* webpackChunkName: "Leccion2c" */ '../views/PrimariaC/LeccionC2.vue'),
        props: true
     },
     { 
      path: 'leccion3c',
      name:'leccion3c',
      component: () => import(/* webpackChunkName: "Leccion3c" */ '../views/PrimariaC/LeccionC3.vue'),
      props: true
   
     },
     { 
      path: 'leccion4c',
      name:'leccion4c',
      component: () => import(/* webpackChunkName: "Leccion4c" */ '../views/PrimariaC/LeccionC4.vue'),
      props: true
     },
     { 
      path: 'leccion5c',
      name:'leccion5c',
      component: () => import(/* webpackChunkName: "Leccion5c" */ '../views/PrimariaC/LeccionC5.vue'),
      props: true
     },
     { 
      path: 'leccion6c',
      name:'leccion6c',
      component: () => import(/* webpackChunkName: "Leccion6c" */ '../views/PrimariaC/LeccionC6.vue'),
      props: true
     },
  ]
  },
  // //PrimariaD
  {
    path: '/primaria-d',
    name:'primariad',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Layout" */ '../components/AuthLayout.vue'),
    props:true,
    children: [
   
      { 
          path: 'leccion1d',
          name:'leccion1d',
          component: () => import(/* webpackChunkName: "Leccion1d" */ '../views/PrimariaD/LeccionD1.vue'),
          props: true
      },
      { 
          path: 'leccion2d',
          name:'leccion2d',
          component: () => import(/* webpackChunkName: "Leccion2d" */ '../views/PrimariaD/LeccionD2.vue'),
          props: true
      },
      { 
          path: 'leccion3d',
          name:'leccion3d',
          component: () => import(/* webpackChunkName: "Leccion3d" */ '../views/PrimariaD/LeccionD3.vue'),
          props: true
      },
      { 
        path: 'leccion4d',
        name:'leccion4d',
        component: () => import(/* webpackChunkName: "Leccion4d" */ '../views/PrimariaD/LeccionD4.vue'),
        props: true
    },
      { 
        path: 'leccion5d',
        name:'leccion5d',
        component: () => import(/* webpackChunkName: "Leccion5d" */ '../views/PrimariaD/LeccionD5.vue'),
        props: true
    },
      { 
        path: 'leccion6d',
        name:'leccion6d',
        component: () => import(/* webpackChunkName: "Leccion6d" */ '../views/PrimariaD/LeccionD6.vue'),
        props: true
      },
   
  ]
  },
  // //PrimariaE
  {
    path: '/primaria-e',
    name:'primariae',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Layout" */ '../components/AuthLayout.vue'),
    props:true,
    children: [
   
      { 
          path: 'leccion1e',
          name:'leccion1e',
          component: () => import(/* webpackChunkName: "Leccion1e" */ '../views/PrimariaE/LeccionE1.vue'),
          props: true
      },
      { 
        path: 'leccion2e',
        name:'leccion2e',
        component: () => import(/* webpackChunkName: "Leccion2b" */ '../views/PrimariaE/LeccionE2.vue'),
        props: true
      },
      { 
        path: 'leccion3e',
        name:'leccion3e',
        component: () => import(/* webpackChunkName: "Leccion3b" */ '../views/PrimariaE/LeccionE3.vue'),
        props: true
      },
      { 
        path: 'leccion4e',
        name:'leccion4e',
        component: () => import(/* webpackChunkName: "Leccion4b" */ '../views/PrimariaE/LeccionE4.vue'),
        props: true
      },
      { 
        path: 'leccion5e',
        name:'leccion5e',
        component: () => import(/* webpackChunkName: "Leccion5b" */ '../views/PrimariaE/LeccionE5.vue'),
        props: true
      },
      { 
        path: 'leccion6e',
        name:'leccion6e',
        component: () => import(/* webpackChunkName: "Leccion6b" */ '../views/PrimariaE/LeccionE6.vue'),
        props: true
      },
   
  ]
  },
  // //PrimariaF
  {
    path: '/primaria-f',
    name:'primariaf',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Layout" */ '../components/AuthLayout.vue'),
    props:true,
    children: [
   
      { 
          path: 'leccion1f',
          name:'leccion1f',
          component: () => import(/* webpackChunkName: "Leccion1f" */ '../views/PrimariaF/LeccionF1.vue'),
          props: true
      },
      { 
        path: 'leccion2f',
        name:'leccion2f',
        component: () => import(/* webpackChunkName: "Leccion2f" */ '../views/PrimariaF/LeccionF2.vue'),
        props: true
      },
      { 
        path: 'leccion3f',
        name:'leccion3f',
        component: () => import(/* webpackChunkName: "Leccion3f" */ '../views/PrimariaF/LeccionF3.vue'),
        props: true
      },
      { 
        path: 'leccion4f',
        name:'leccion4f',
        component: () => import(/* webpackChunkName: "Leccion4f" */ '../views/PrimariaF/LeccionF4.vue'),
        props: true
      },
      { 
        path: 'leccion5f',
        name:'leccion5f',
        component: () => import(/* webpackChunkName: "Leccion5f" */ '../views/PrimariaF/LeccionF5.vue'),
        props: true
      },
      { 
        path: 'leccion6f',
        name:'leccion6f',
        component: () => import(/* webpackChunkName: "Leccion6f" */ '../views/PrimariaF/LeccionF6.vue'),
        props: true
      },
   
  ]
  },
   // //SecundariaA
  {
    path: '/secundaria-a',
    name:'secundariaa',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Layout" */ '../components/AuthLayout.vue'),
    props:true,
    children: [
   
      { 
          path: 'leccion1a',
          name:'leccion1a',
          component: () => import(/* webpackChunkName: "Leccion1A" */ '../views/SecundariaA/LeccionA1.vue'),
          props: true
      },
      { 
        path: 'leccion2a',
        name:'leccion2a',
        component: () => import(/* webpackChunkName: "Leccion2A" */ '../views/SecundariaA/LeccionA2.vue'),
        props: true
      },
      { 
        path: 'leccion3a',
        name:'leccion3a',
        component: () => import(/* webpackChunkName: "Leccion3A" */ '../views/SecundariaA/LeccionA3.vue'),
        props: true
      },
      { 
        path: 'leccion4a',
        name:'leccion4a',
        component: () => import(/* webpackChunkName: "Leccion4A" */ '../views/SecundariaA/LeccionA4.vue'),
        props: true
      },
      { 
        path: 'leccion5a',
        name:'leccion5a',
        component: () => import(/* webpackChunkName: "Leccion5A" */ '../views/SecundariaA/LeccionA5.vue'),
        props: true
      },
      { 
        path: 'leccion6a',
        name:'leccion6a',
        component: () => import(/* webpackChunkName: "Leccion6A" */ '../views/SecundariaA/LeccionA6.vue'),
        props: true
      },
   
  ]
  },
  // //SecundariaB
  {
    path: '/secundaria-b',
    name:'secundariab',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Layout" */ '../components/AuthLayout.vue'),
    props:true,
    children: [
   
      { 
          path: 'leccion1b',
          name:'secundaria1b',
          component: () => import(/* webpackChunkName: "Leccion1B" */ '../views/SecundariaB/LeccionB1.vue'),
          props: true
      },
      { 
        path: 'leccion2b',
        name:'leccion2ab',
        component: () => import(/* webpackChunkName: "Leccion2SB" */ '../views/SecundariaB/LeccionB2.vue'),
        props: true
      },
      { 
        path: 'leccion3b',
        name:'leccion3sb',
        component: () => import(/* webpackChunkName: "Leccion3SB" */ '../views/SecundariaB/LeccionB3.vue'),
        props: true
      },
      { 
        path: 'leccion4b',
        name:'leccion4sb',
        component: () => import(/* webpackChunkName: "Leccion4SB" */ '../views/SecundariaB/LeccionB4.vue'),
        props: true
      },
      { 
        path: 'leccion5b',
        name:'leccion5sb',
        component: () => import(/* webpackChunkName: "Leccion5SB" */ '../views/SecundariaB/LeccionB5.vue'),
        props: true
      },
      { 
        path: 'leccion6b',
        name:'leccion6sb',
        component: () => import(/* webpackChunkName: "Leccion6SB" */ '../views/SecundariaB/LeccionB6.vue'),
        props: true
      },
   
  ]
  },
  // //SecundariaC
  {
    path: '/secundaria-c',
    name:'secundariac',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Layout" */ '../components/AuthLayout.vue'),
    props:true,
    children: [
   
      { 
          path: 'leccion1c',
          name:'leccion1sc',
          component: () => import(/* webpackChunkName: "Leccion1c" */ '../views/SecundariaC/LeccionC1.vue'),
          props: true
      },
      { 
        path: 'leccion2c',
        name:'leccion2sc',
        component: () => import(/* webpackChunkName: "Leccion2c" */ '../views/SecundariaC/LeccionC2.vue'),
        props: true
      },
      { 
        path: 'leccion3c',
        name:'leccion3sc',
        component: () => import(/* webpackChunkName: "Leccion3c" */ '../views/SecundariaC/LeccionC3.vue'),
        props: true
      },
      { 
        path: 'leccion4c',
        name:'leccion4sc',
        component: () => import(/* webpackChunkName: "Leccion4c" */ '../views/SecundariaC/LeccionC4.vue'),
        props: true
      },
      { 
        path: 'leccion5c',
        name:'leccion5sc',
        component: () => import(/* webpackChunkName: "Leccion5c" */ '../views/SecundariaC/LeccionC5.vue'),
        props: true
      },
      { 
        path: 'leccion6c',
        name:'leccion6sc',
        component: () => import(/* webpackChunkName: "Leccion6c" */ '../views/SecundariaC/LeccionC6.vue'),
        props: true
      },
   
  ]
  },
  //Complementos
  {
    path: '/complementarios',
    name:'complementarios',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Layout" */ '../components/AuthLayout.vue'),
    props:true,
    children: [
   
      { 
          path: 'cancion1',
          name:'cancion1',
          component: () => import(/* webpackChunkName: "Cancion 01" */ '../views/Complementarios/Cancion01.vue'),
          props: true
      },
      { 
        path: 'cancion2',
        name:'cancion2',
        component: () => import(/* webpackChunkName: "cancion 02" */ '../views/Complementarios/Cancion02.vue'),
        props: true
     },
     { 
      path: 'cancion3',
      name:'cancion3',
      component: () => import(/* webpackChunkName: "cancion 03" */ '../views/Complementarios/Cancion03.vue'),
      props: true
     },
     { 
      path: 'cancion4',
      name:'cancion4',
      component: () => import(/* webpackChunkName: "cancion 04" */ '../views/Complementarios/Cancion04.vue'),
      props: true
     },
     { 
      path: 'cancion5',
      name:'cancion5',
      component: () => import(/* webpackChunkName: "cancion 05" */ '../views/Complementarios/Cancion05.vue'),
      props: true
     },
     { 
      path: 'cancion6',
      name:'cancion6',
      component: () => import(/* webpackChunkName: "cancion 06" */ '../views/Complementarios/Cancion06.vue'),
      props: true
     },
     { 
      path: 'cancion7',
      name:'cancion7',
      component: () => import(/* webpackChunkName: "cancion 07" */ '../views/Complementarios/Cancion07.vue'),
      props: true
     },
     { 
      path: 'cancion8',
      name:'cancion8',
      component: () => import(/* webpackChunkName: "cancion 08" */ '../views/Complementarios/Cancion08.vue'),
      props: true
     },
     { 
      path: 'cancion9',
      name:'cancion9',
      component: () => import(/* webpackChunkName: "cancion 09" */ '../views/Complementarios/Cancion09.vue'),
      props: true
     },
     { 
      path: 'cancion10',
      name:'cancion10',
      component: () => import(/* webpackChunkName: "cancion 10" */ '../views/Complementarios/Cancion10.vue'),
      props: true
     },
     { 
      path: 'cancion11',
      name:'cancion11',
      component: () => import(/* webpackChunkName: "cancion 11" */ '../views/Complementarios/Cancion11.vue'),
      props: true
     },
     { 
      path: 'cancion12',
      name:'cancion12',
      component: () => import(/* webpackChunkName: "cancion 12" */ '../views/Complementarios/Cancion12.vue'),
      props: true
     },
     { 
      path: 'cancion13',
      name:'cancion13',
      component: () => import(/* webpackChunkName: "cancion 13" */ '../views/Complementarios/Cancion13.vue'),
      props: true
     },
   
  ]
  }
]

const router = new VueRouter({
  routes
})

export default router
